// import { useState } from "react";
// import { OCCUPANCY_LABELS, OCCUPANCY_OPTIONS } from "../TrucoUtilities/lobby.utils";
// import { RadioGroup } from "../TrucoUtilities/RadioGroup";

// export function TablesList({ visibleTables, joinTable }) {
//     const [selectedOccupancy, setSelectedOccupancy] = useState('all');

//     return <table className="tables-table">
//         <thead>
//             <tr>
//                 <th className="truco-table-list">Table</th>
//                 <th className="truco-table-list">Seats : <RadioGroup
//                     title=""
//                     options={OCCUPANCY_OPTIONS}
//                     value={selectedOccupancy}
//                     getLabel={(o) => (o.toString().toLowerCase() === 'all' ? 'ALL' : OCCUPANCY_LABELS[o])}
//                     onChange={setSelectedOccupancy}
//                 /></th>
//                 <th className="truco-table-list">Action</th>
//             </tr>
//         </thead>
//         <tbody>
//             {visibleTables.map((t) => (
//                 <tr key={t.tableId}>
//                     <td className="truco-table-list">{t.tableId}</td>
//                     <td className="truco-table-list">{t.numOccupiedSeats}/{t.numberOfSeats}</td>
//                     <td className="truco-table-list">
//                         <button type='button' disabled={!t.canJoin} onClick={() => { joinTable(t.tableId) }}>
//                             {t.numOccupiedSeats ? t.numOccupiedSeats === t.numberOfSeats ? 'FULL' : 'WAITING' : 'JOIN'}
//                         </button>
//                     </td>
//                 </tr>
//             ))}
//         </tbody>
//     </table>;
// }


import { useState, useMemo } from "react";
import { OCCUPANCY_LABELS, OCCUPANCY_OPTIONS, sortTables } from "../TrucoUtilities/lobby.utils";
import { RadioGroup } from "../TrucoUtilities/RadioGroup";
import { HiArrowsUpDown } from "react-icons/hi2";

// ── Sort-icon component ───────────────────────────────────────────────────────
// Shows ↑ / ↓ when this column is the active sort key; ⇅ when inactive.
function SortIcon({ column, sortKey, sortDir }) {
    const isActive = sortKey === column;
    const style = {
        display: "inline-flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        marginLeft: 5,
        gap: 1,
        verticalAlign: "middle",
        opacity: isActive ? 1 : 1,
        fontSize: "0.65em",
        lineHeight: 1,
        userSelect: "none",
    };

    if (!isActive) {
        return (
            <span style={style}>
                <HiArrowsUpDown className="nonSortIndex" fill="currentColor" />
            </span>
        );
    }
    return (
        <span style={style}>
            {sortDir === "asc"
                ? <span style={{ color: "#fff", fontSize: "1.5em" }}>▲</span>
                : <span style={{ color: "#fff", fontSize: "1.5em" }}>▼</span>
            }
        </span>
    );
}

// ── Component ─────────────────────────────────────────────────────────────────
export function TablesList({ visibleTables, joinTable }) {
    const [selectedOccupancy, setSelectedOccupancy] = useState("all");
    const [sortKey, setSortKey] = useState("TABLE_ID");
    const [sortDir, setSortDir] = useState("asc");

    // Toggle: clicking the active column flips direction; clicking a new column
    // sets it as active with ascending order.
    const handleSort = (column) => {
        if (sortKey === column) {
            setSortDir((d) => (d === "asc" ? "desc" : "asc"));
        } else {
            setSortKey(column);
            setSortDir("asc");
        }
    };

    // Apply occupancy filter then sort via lobby.utils
    const rows = useMemo(() => {
        const filtered =
            selectedOccupancy === "all"
                ? visibleTables
                : visibleTables.filter((t) => {
                    if (selectedOccupancy === "empty") return t.numOccupiedSeats === 0;
                    if (selectedOccupancy === "waiting") return t.numOccupiedSeats > 0 && t.numOccupiedSeats < t.numberOfSeats;
                    if (selectedOccupancy === "full") return t.numOccupiedSeats === t.numberOfSeats;
                    return true;
                });
        return sortTables(filtered, sortKey, sortDir);
    }, [visibleTables, selectedOccupancy, sortKey, sortDir]);

    // Shared style for sortable <th> elements
    const thSort = {
        cursor: "pointer",
        userSelect: "none",
        whiteSpace: "nowrap",
    };

    return (
        <table className="tables-table">
            <thead>
                <tr>
                    {/* ── Table ID column ───────────────────────── */}
                    <th
                        className="truco-table-list"
                        style={thSort}
                        onClick={() => handleSort("TABLE_ID")}
                        title="Sort by Table ID"
                    >
                        <SortIcon column="TABLE_ID" sortKey={sortKey} sortDir={sortDir} />
                        Table
                    </th>

                    {/* ── Seats / Occupancy column ──────────────── */}
                    <th
                        className="truco-table-list"
                        style={thSort}
                        title="Sort by occupancy"
                    >
                        {/* Clicking the label text sorts; the RadioGroup is a separate control */}
                        <span
                            onClick={() => handleSort("SEATS_AVAILABLE")}
                            style={{ marginRight: "15px" }}
                        >
                            <SortIcon column="SEATS_AVAILABLE" sortKey={sortKey} sortDir={sortDir} />
                            Seats
                        </span>
                        {/* {" : "} */}
                        <RadioGroup
                            title=""
                            options={OCCUPANCY_OPTIONS}
                            value={selectedOccupancy}
                            getLabel={(o) =>
                                o.toString().toLowerCase() === "all"
                                    ? "ALL"
                                    : OCCUPANCY_LABELS[o]
                            }
                            onChange={setSelectedOccupancy}
                        />
                    </th>

                    {/* ── Action column (not sortable) ──────────── */}
                    <th className="truco-table-list">Action</th>
                </tr>
            </thead>
            <tbody className="truco-table-body">
                {rows.map((t) => (
                    <tr key={t.tableId} className="row-animate" onDoubleClick={() => joinTable(t.tableId)}>
                        <td className="truco-table-list">{t.tableId}</td>
                        <td className="truco-table-list">
                            {t.numOccupiedSeats}/{t.numberOfSeats}
                        </td>
                        <td className="truco-table-list">
                            <button
                                className="truco-button"
                                type="button"
                                disabled={!t.canJoin}
                                onClick={() => joinTable(t.tableId)}
                            >
                                {t.numOccupiedSeats
                                    ? t.numOccupiedSeats === t.numberOfSeats
                                        ? "FULL"
                                        : "WAITING"
                                    : "JOIN"}
                            </button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}